<template>
  <page-header-wrapper>
    <div class="business-page erp-list-page baidao-list-page stock-flow-page">
      <section class="erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="仓库">
                <a-select v-model="query.warehouseId" allow-clear placeholder="全部仓库">
                  <a-select-option v-for="item in warehouses" :key="item.id" :value="item.id">
                    {{ item.warehouseCode }} · {{ item.warehouseName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="商品分类">
                <a-tree-select
                  v-model="query.categoryId"
                  allow-clear
                  show-search
                  tree-node-filter-prop="title"
                  :dropdown-style="{ maxHeight: '360px', overflow: 'auto' }"
                  placeholder="全部分类"
                  :tree-data="categoryTreeSelect"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="流水号">
                <a-input v-model="query.flowNo" allow-clear placeholder="库存流水号" @pressEnter="load(true)" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="流水类型">
                <a-select v-model="query.flowType" allow-clear placeholder="全部">
                  <a-select-option v-for="item in flowTypeOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="业务类型">
                <a-select v-model="query.bizType" allow-clear placeholder="全部">
                  <a-select-option v-for="item in bizTypeOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="SPU编码">
                <a-input v-model="query.spuCode" allow-clear placeholder="SPU编码" @pressEnter="load(true)" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="商品名称">
                <a-input v-model="query.spuName" allow-clear placeholder="商品名称" @pressEnter="load(true)" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="SKU编码">
                <a-input v-model="query.skuCode" allow-clear placeholder="SKU编码" @pressEnter="load(true)" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="规格名称">
                <a-input v-model="query.specName" allow-clear placeholder="规格名称" @pressEnter="load(true)" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="发生时间">
                <a-range-picker v-model="dateRange" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24" class="erp-search-actions">
              <a-button type="primary" icon="search" @click="load(true)">查询</a-button>
              <a-button icon="redo" @click="resetQuery">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </section>

      <section class="erp-table-card">
        <div class="erp-table-toolbar">
          <div>
            <h3>库存流水</h3>
            <p>记录采购/销售/期初/其他/盘点等业务审核后写入的实物库存变动；销售订单占用不在此列表。</p>
          </div>
          <div class="erp-toolbar-actions">
            <a-button @click="$router.push('/erp/stock-ledger')">返回库存台账</a-button>
          </div>
        </div>
        <a-table
          :columns="columns"
          :data-source="rows"
          :loading="loading"
          row-key="id"
          bordered
          size="middle"
          :scroll="{ x: 2100 }"
          :pagination="pagination"
          :locale="{ emptyText: '暂无库存流水' }"
          @change="onPageChange">
          <template slot="qty" slot-scope="value">
            <span class="erp-money">{{ formatQty(value) }}</span>
          </template>
          <template slot="reversal" slot-scope="value">
            <a-tag v-if="value === 1" color="orange">反冲</a-tag>
            <span v-else>—</span>
          </template>
          <template slot="time" slot-scope="value">{{ value || '—' }}</template>
          <template slot="doc" slot-scope="text, record">
            <span>{{ text || record.sourceOrderTypeName || '—' }}</span>
          </template>
        </a-table>
      </section>
    </div>
  </page-header-wrapper>
</template>

<script>
import { listWarehouse } from '@/api/erp/warehouse'
import { pageStockInventoryFlow } from '@/api/erp/stock'
import { treeProductCategory } from '@/api/erp/productCategory'

const emptyQuery = () => ({
  warehouseId: undefined,
  categoryId: undefined,
  flowNo: '',
  flowType: undefined,
  bizType: undefined,
  skuCode: '',
  spuCode: '',
  spuName: '',
  specName: ''
})

export default {
  name: 'ErpStockFlow',
  data () {
    return {
      query: emptyQuery(),
      dateRange: [],
      warehouses: [],
      categoryTreeRaw: [],
      rows: [],
      loading: false,
      syncedRouteQueryKey: '',
      pagination: { current: 1, pageSize: 20, total: 0, showSizeChanger: true, showTotal: total => `共 ${total} 条` },
      flowTypeOptions: [
        { value: 'in', label: '入库' },
        { value: 'out', label: '出库' },
        { value: 'reversal', label: '反冲' },
        { value: 'transfer_in', label: '调拨入' },
        { value: 'transfer_out', label: '调拨出' }
      ],
      bizTypeOptions: [
        { value: 'purchase_inbound', label: '采购入库' },
        { value: 'sales_outbound', label: '销售出库' },
        { value: 'sales_return', label: '销售退货' },
        { value: 'opening_balance', label: '库存期初' },
        { value: 'warehouse_other_in', label: '其他入库' },
        { value: 'warehouse_other_out', label: '其他出库' },
        { value: 'warehouse_profit', label: '盘盈' },
        { value: 'warehouse_loss', label: '盘亏' }
      ],
      columns: [
        { title: '发生时间', dataIndex: 'createTime', width: 168, scopedSlots: { customRender: 'time' } },
        { title: '流水号', dataIndex: 'flowNo', width: 200 },
        { title: '流水类型', dataIndex: 'flowTypeName', width: 88 },
        { title: '业务类型', dataIndex: 'bizTypeName', width: 100 },
        { title: '反冲', dataIndex: 'isReversal', width: 72, align: 'center', scopedSlots: { customRender: 'reversal' } },
        { title: '来源单据', dataIndex: 'sourceDocNo', width: 200, scopedSlots: { customRender: 'doc' } },
        { title: '仓库', dataIndex: 'warehouseName', width: 140 },
        { title: 'SPU编码', dataIndex: 'spuCode', width: 130 },
        { title: '商品名称', dataIndex: 'spuName', width: 160 },
        { title: 'SKU编码', dataIndex: 'skuCode', width: 140 },
        { title: '规格', dataIndex: 'specName', width: 140 },
        { title: '基本数量', dataIndex: 'qtyBase', width: 110, align: 'right', scopedSlots: { customRender: 'qty' } },
        { title: '变动前', dataIndex: 'qtyBefore', width: 100, align: 'right', scopedSlots: { customRender: 'qty' } },
        { title: '变动后', dataIndex: 'qtyAfter', width: 100, align: 'right', scopedSlots: { customRender: 'qty' } },
        { title: '单位', dataIndex: 'unitName', width: 72 },
        { title: '成本单价', dataIndex: 'costPrice', width: 100, align: 'right', scopedSlots: { customRender: 'qty' } },
        { title: '成本金额', dataIndex: 'costAmount', width: 110, align: 'right', scopedSlots: { customRender: 'qty' } }
      ]
    }
  },
  computed: {
    categoryTreeSelect () {
      return this.toTreeSelectData(this.categoryTreeRaw)
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.path !== '/erp/stock-flow') return
      if (from && from.path === to.path && this.isSameRouteQuery(to.query, from.query)) return
      this.syncQueryFromRoute(true)
    }
  },
  created () {
    this.syncQueryFromRoute(false)
    listWarehouse().then(res => { this.warehouses = res.data || [] })
    treeProductCategory().then(res => {
      this.categoryTreeRaw = this.normalizeTree((res && res.data) || [])
    }).catch(() => { this.categoryTreeRaw = [] }).finally(() => this.load(true))
  },
  activated () {
    if (this.$route.path !== '/erp/stock-flow') return
    this.syncQueryFromRoute(true)
  },
  methods: {
    routeQueryKey () {
      return JSON.stringify(this.$route.query || {})
    },
    syncQueryFromRoute (reload) {
      const key = this.routeQueryKey()
      if (reload && key === this.syncedRouteQueryKey) return
      this.applyRouteQuery()
      this.syncedRouteQueryKey = key
      if (reload) this.load(true)
    },
    isSameRouteQuery (a, b) {
      const keys = new Set([...Object.keys(a || {}), ...Object.keys(b || {})])
      for (const key of keys) {
        const va = a && a[key] != null ? String(a[key]) : ''
        const vb = b && b[key] != null ? String(b[key]) : ''
        if (va !== vb) return false
      }
      return true
    },
    applyRouteQuery () {
      const q = this.$route.query || {}
      const next = emptyQuery()
      const textKeys = ['spuCode', 'spuName', 'skuCode', 'specName']
      textKeys.forEach(key => {
        const v = q[key]
        if (v != null && String(v).trim() !== '') {
          next[key] = String(v).trim()
        }
      })
      if (q.warehouseId != null && String(q.warehouseId).trim() !== '') {
        const wid = Number(q.warehouseId)
        if (!Number.isNaN(wid)) next.warehouseId = wid
      }
      if (q.categoryId != null && String(q.categoryId).trim() !== '') {
        const cid = Number(q.categoryId)
        if (!Number.isNaN(cid)) next.categoryId = cid
      }
      this.query = next
    },
    normalizeTree (nodes) {
      return (nodes || []).map(n => ({
        id: n.id,
        categoryName: n.categoryName || n.name,
        children: this.normalizeTree(n.children || [])
      }))
    },
    toTreeSelectData (nodes) {
      return (nodes || []).map(n => ({
        title: n.categoryName,
        value: n.id,
        key: String(n.id),
        children: n.children && n.children.length ? this.toTreeSelectData(n.children) : undefined
      }))
    },
    formatQty (value) {
      if (value == null || value === '') return '—'
      return Number(value).toFixed(3)
    },
    buildParams () {
      const params = {
        ...this.query,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.dateStart = this.dateRange[0].format('YYYY-MM-DD')
        params.dateEnd = this.dateRange[1].format('YYYY-MM-DD')
      }
      return params
    },
    load (reset) {
      if (reset) this.pagination.current = 1
      this.loading = true
      pageStockInventoryFlow(this.buildParams()).then(res => {
        const page = res.data || {}
        this.rows = page.records || []
        this.pagination.total = page.total || 0
      }).catch(e => this.$message.error((e && e.message) || '加载失败')).finally(() => { this.loading = false })
    },
    resetQuery () {
      this.query = emptyQuery()
      this.dateRange = []
      this.load(true)
    },
    onPageChange (pager) {
      this.pagination.current = pager.current
      this.pagination.pageSize = pager.pageSize
      this.load(false)
    }
  }
}
</script>
